module.exports = __webpack_public_path__ + "assets/img/business-ecology-icon1-new.8a0b1221.png";